import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { User, UserService } from './user.service';

interface IViewState {
  isMobileMenuOpen: boolean;
  isUserLoggedIn: boolean;
  isLoading: boolean;
  isAssessment: boolean;
  isBadge: boolean;
}
export class ViewState implements IViewState {
  isMobileMenuOpen = false;
  isUserLoggedIn = false;
  isLoading = false;
  isAssessment = false;
  isBadge = false;
}

@Injectable()
export class ViewStateService {
  private _currentState: ViewState;
  state$: BehaviorSubject<ViewState>;

  constructor(private userService: UserService) {
    this._currentState = new ViewState();
    //this._currentState.isPractitionerStatusActive = true;    
    this.state$ = new BehaviorSubject(this._currentState);

    this._currentState.isUserLoggedIn = (this.userService.CurrentUser) ? true : false;

    this.state$.next(this._currentState);

    this.userService.user$.subscribe(u => this.handleUserChanges(u));
  }

  get CurrentViewState() {
    return this._currentState;
  }

  startLoading() {
    this._currentState.isLoading = true;
    this.state$.next(this._currentState);
  }

  stopLoading() {
    this._currentState.isLoading = false;
    this.state$.next(this._currentState);
  }

  toggleMobileMenu() {
    if (this._currentState.isMobileMenuOpen)
      this._currentState.isMobileMenuOpen = false;
    else
      this._currentState.isMobileMenuOpen = true;

    this.state$.next(this._currentState);
  }

  isAssessmentModule(isAssessment: boolean) {
    this._currentState.isAssessment = isAssessment;
    this.state$.next(this._currentState);
  }

  isBadge(isBadge: boolean) {
    this._currentState.isBadge = isBadge;
    this.state$.next(this._currentState);
  }

  private handleUserChanges(user: User) {
    if (!user)
      this._currentState.isUserLoggedIn = false;
    else {
      this._currentState.isUserLoggedIn = true;
    }

    this.state$.next(this._currentState);
  }
}
